import { logMethodCall } from './debug';
import Event from '../const/event';
import { KEY_UNREAD_NOTIFICATIONS_COUNT } from '../const/common';

export function initHideUnsupported() {
  const hideUnsupportedContainers = document.querySelectorAll('.cleverpush-hide-unsupported');
  for (let i = 0; i < hideUnsupportedContainers.length; i += 1) {
    const hideUnsupportedContainer = hideUnsupportedContainers[i];
    hideUnsupportedContainer.style.setProperty('display', 'none', 'important');
  }
}

export function initNotificationId(setNotificationId) {
  const notificationId = localStorage.getItem('cleverpush-notification-id');
  const notificationLastInteraction = parseInt(localStorage.getItem('cleverpush-notification-last-interaction'), 10) || 0;
  if (notificationId && (!notificationLastInteraction || (Date.now() - notificationLastInteraction < (30 * 60 * 1000)))) {
    setNotificationId(notificationId);
    localStorage.setItem('cleverpush-notification-last-interaction', Date.now());
  } else {
    localStorage.removeItem('cleverpush-notification-last-interaction');
    localStorage.removeItem('cleverpush-notification-id');
  }
}

export function initTopicButtons(context) {
  logMethodCall('initTopicButtons');

  context.topicButtons = context.topicButtons || [];

  const topicButtons = document.querySelectorAll('.cleverpush-topic-button');
  if (topicButtons.length) {
    import('../topicButton').then(({ default: TopicButton }) => {
      for (let i = 0; i < topicButtons.length; i += 1) {
        const element = topicButtons[i];
        const topicButton = new TopicButton(i, element, context.config, context.subscriptionManager, context.api, context.triggerOptIn.bind(context));

        context.on(Event.SUBSCRIBED, () => {
          topicButton.reset(true);
        });
        context.on(Event.TOPICS_SET, () => {
          topicButton.init();
        });
        context.on(Event.UNSUBSCRIBED, () => {
          topicButton.reset(false);
        });

        context.topicButtons.push(topicButton);
      }
    });
  }
}

export function setUrlSessionConfig(configParam, config, api) {
  if (config.multiChannels && config.multiChannels.telegramChannel && config.multiChannels.telegramChannel._id !== config.channelId && !configParam.forceChannelId) {
    config.channelId = config.multiChannels.telegramChannel._id;
    api.channelId = config.multiChannels.telegramChannel._id;
  } else if (config.multiChannels && config.multiChannels.facebookChannel && config.multiChannels.facebookChannel._id !== config.channelId && !configParam.forceChannelId) {
    config.channelId = config.multiChannels.facebookChannel._id;
    api.channelId = config.multiChannels.facebookChannel._id;
  }
}

export function checkAutoBalanceShouldShowAlert(optInRate, minimumOptInRate) {
  const minPercentToAlwaysShowNativeOptInDirectly = minimumOptInRate * 2;
  const minPercentNecessaryToShowNativeOptInDirectly = minimumOptInRate * 1.05;
  let chanceToDirectlyShowNativeOptIn = (100 / Math.pow(minPercentToAlwaysShowNativeOptInDirectly - minPercentNecessaryToShowNativeOptInDirectly, 2)) * Math.pow(optInRate - minPercentNecessaryToShowNativeOptInDirectly, 2);
  chanceToDirectlyShowNativeOptIn = chanceToDirectlyShowNativeOptIn || 0;
  // Make sure its between 0 and 100
  chanceToDirectlyShowNativeOptIn = Math.max(0, Math.min(100, chanceToDirectlyShowNativeOptIn));
  if (Math.random() * 100 <= chanceToDirectlyShowNativeOptIn) {
    // show native opt in directly
    return true;
  }
  return false;
}

export function checkEndSession(lastSession, subscriptionId) {
  if (lastSession && lastSession.lastInteractionAt && lastSession.startedAt && new Date(lastSession.lastInteractionAt) < new Date(Date.now() - (60 * 60 * 30))) {
    let duration = Math.round((new Date(lastSession.lastInteractionAt).getTime() - new Date(lastSession.startedAt).getTime()) / 1000);
    if (duration > 60 * 60 * 30) {
      duration = 60 * 60 * 30;
    } else if (duration < 0) {
      duration = 0;
    }
    if (subscriptionId) {
      this.api.endSession(subscriptionId, {
        duration,
        visits: lastSession.visits
      });
    }

    lastSession = {};
  }
}

export function appendCounterElement(link) {
  const count = localStorage.getItem(KEY_UNREAD_NOTIFICATIONS_COUNT);
  const counterEl = parent.document.createElement('span');
  counterEl.className = 'cleverpush-unread-notifications-count';
  counterEl.innerText = count;
  link.appendChild(counterEl);
}

// Return true if we have unread notifications
export function hasUnreadNotifications(subscriptionManager) {
  return new Promise((resolve, reject) => {
    subscriptionManager.getStoredNotifications().then((notifications) => {
      const storageManager = subscriptionManager.storageManager;
      if (!storageManager.checkUnreadNotifications) {
        resolve(false);
        return;
      }
      const unread = storageManager.checkUnreadNotifications(notifications);
      resolve(unread);
    }).catch((err) => {
      reject(new Error(err));
    });
  });
}
